import { Text } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/src/components/constants';
import React from 'react';

const AssignLessonDateTabEmpty = () => {
    return (
        <div className="assignment__empty-stub">
            <Text id="assignLessonModal.dateTab.empty" type={TEXT_MARKUP_TYPE.MARKDOWN} />
        </div>
    );
};

export default AssignLessonDateTabEmpty;
